import type { Office, WorkSchedule } from "@/types/offices"
import { API_ROOT, HttpClient } from "@/api/httpClient"

export interface OfficePayload {
	name: string
	address: string
	city: string
	province: string
	country: string
	zip: string
	note?: string | null
	contact_phones: string[]
	contact_emails: string[]
	work_schedule: Partial<WorkSchedule>
}

export default {
	list() {
		return HttpClient.get<Office[]>(`${API_ROOT}/medical-centers/me/offices`)
	},
	create(payload: OfficePayload) {
		return HttpClient.post<Office>(`${API_ROOT}/medical-centers/me/offices`, payload)
	},
	update(officeId: number, payload: OfficePayload) {
		return HttpClient.put<Office>(`${API_ROOT}/medical-centers/me/offices/${officeId}`, payload)
	},
	delete(officeId: number) {
		return HttpClient.delete(`${API_ROOT}/medical-centers/me/offices/${officeId}`)
	}
}
